import type { IAssetsFilterValues } from "@pages/assets/interface";

export const assetsFilterInitialValues: IAssetsFilterValues = {
  search: null,
  category_id: null,
  type_id: null,
  available: null,
};
